var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSoundOff = function SvgIconSoundOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-sound-off_svg__cls-1{stroke-linecap:round;stroke-linejoin:round;fill:none;stroke:#000;stroke-width:.75px}"))), /*#__PURE__*/React.createElement("path", {
    d: "M17.29 21.45v.35c0 .29-.12.53-.4.64-.27.11-.52.06-.75-.13-.96-.78-1.93-1.56-2.9-2.34-.18-.14-.38-.25-.53-.42-.49-.54-1.08-.68-1.79-.63-.59.05-1.18.04-1.77 0-1.35-.11-2.42-1.15-2.54-2.56-.08-.94-.07-1.89.02-2.83.13-1.39 1.37-2.45 2.77-2.46.73 0 1.46-.01 2.19 0 .24 0 .43-.06.61-.21 1.29-1.05 2.59-2.08 3.88-3.13.25-.21.52-.31.83-.16.32.15.38.43.38.75v13.13Z",
    style: {
      strokeMiterlimit: 10,
      fill: "none",
      stroke: "#000",
      strokeWidth: ".75px"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-sound-off_svg__cls-1",
    d: "m19.42 12.98 4.01 4.01M23.43 12.98l-4.01 4.01"
  })));
};
export default SvgIconSoundOff;